import { useState, useEffect } from "react";
import { getClientsList } from "../modules/api/salesPurchases";
import { userClientDb } from "../modules/auth/selectors/userSelector";
import { useSelector } from "react-redux";
import axios, { Canceler } from "axios";

function useClientsFetching(fil: string, pageNumber: number, module: string) {
  const clientDb = useSelector(userClientDb);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [clients, setClients] = useState<any[]>([]);
  const [hasMore, setHasMore] = useState(false);

  useEffect(() => {
    setClients([]);
  }, [fil]);

  useEffect(() => {
    setLoading(true);
    setError(undefined);
    let cancel: Canceler;

    const query = {
      clientDbId: clientDb ? clientDb.id : 0,
      module: module,
      pageNumber: pageNumber,
      fil: fil,
    };

    const config = {
      cancelToken: new axios.CancelToken((c) => (cancel = c)),
    };

    getClientsList(query, config)
      .then(({ data }) => {
        setClients((prevClients: any[]) => {
          return [...prevClients, ...data];
        });
        setLoading(false);
        // setHasMore(data.length > 0);
        setHasMore(data.length > 0 && data[0].pageNumber > pageNumber);
      })
      .catch((err) => {
        if (axios.isCancel(err)) return;
        setError(err);
      });

    return () => cancel();
  }, [fil, pageNumber, clientDb, module]);

  return { loading, error, clients, hasMore };
}

export default useClientsFetching;
